import React, { useEffect, useState } from "react";
import { guardarEstudio, obtenerEstudio } from "../api";
import { toast } from "react-toastify";
import { HiSave, HiX, HiOutlineChartPie } from "react-icons/hi";
import "../styles.css";

const DetalleCostesIndirectos = ({ numeroExpediente, onCerrar }) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    const cargar = async () => {
      try {
        const estudio = await obtenerEstudio(numeroExpediente, "detalle_costes");
        if (estudio) setData(estudio);
      } catch {
        console.warn("Sin datos previos");
      } finally {
        setLoading(false);
      }
    };
    cargar();
  }, [numeroExpediente]);

  const handleChange = (campo, subcampo, valor) => {
    const fila = data[campo] || { numero: 0, meses: 0, coste: 0, importe: 0 };
    const nuevo = { ...fila, [subcampo]: valor };
    nuevo.importe =
      (parseFloat(nuevo.numero) || 0) *
      (parseFloat(nuevo.meses) || 0) *
      (parseFloat(nuevo.coste) || 0);
    setData((prev) => ({ ...prev, [campo]: nuevo }));
  };

  const get = (campo, sub) =>
    data[campo]?.[sub] || (sub === "importe" ? 0 : "");

  const handleGuardar = async () => {
    try {
      await guardarEstudio(numeroExpediente, "detalle_costes", data);
      toast.success("Detalle de costes guardado");
    } catch {
      toast.error("Error al guardar detalle");
    }
  };

  const renderFila = (nombre) => (
    <div key={nombre} className="cost-row" style={{
      display: 'grid',
      gridTemplateColumns: '2fr 1fr 1fr 1fr 1.2fr',
      gap: '12px',
      padding: '16px',
      background: 'rgba(255,255,255,0.02)',
      border: '1px solid var(--glass-border)',
      borderRadius: 'var(--radius-md)',
      alignItems: 'center',
      marginBottom: '8px'
    }}>
      <div style={{ fontWeight: 600, fontSize: '0.9rem' }}>{nombre}</div>
      <div>
        <input
          type="number"
          placeholder="Num"
          value={get(nombre, "numero")}
          onChange={(e) => handleChange(nombre, "numero", parseFloat(e.target.value) || 0)}
          style={{ width: '100%', padding: '8px', background: 'var(--bg-main)', border: '1px solid var(--glass-border)', borderRadius: '4px', fontSize: '0.85rem' }}
        />
      </div>
      <div>
        <input
          type="number"
          placeholder="Meses"
          value={get(nombre, "meses")}
          onChange={(e) => handleChange(nombre, "meses", parseFloat(e.target.value) || 0)}
          style={{ width: '100%', padding: '8px', background: 'var(--bg-main)', border: '1px solid var(--glass-border)', borderRadius: '4px', fontSize: '0.85rem' }}
        />
      </div>
      <div>
        <input
          type="number"
          placeholder="Coste €"
          value={get(nombre, "coste")}
          onChange={(e) => handleChange(nombre, "coste", parseFloat(e.target.value) || 0)}
          style={{ width: '100%', padding: '8px', background: 'var(--bg-main)', border: '1px solid var(--glass-border)', borderRadius: '4px', fontSize: '0.85rem' }}
        />
      </div>
      <div style={{ textAlign: 'right', fontWeight: 700, color: 'var(--accent-primary)', fontSize: '0.95rem' }}>
        {get(nombre, "importe").toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €
      </div>
    </div>
  );

  if (loading) return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
      <div className="loader"></div>
    </div>
  );

  const categorias = [
    {
      titulo: "M.O. Indirecta",
      campos: [
        "Gerente", "Jefe de Obra", "Jefe de Producción o Ayte. de Obra",
        "Jefe de Oficina Técnica", "Topógrafo", "Encargado", "Administrativo",
        "Vigilante", "Calidad", "Pilotos RENFE", "Auxiliares Administrativos",
        "Ayudantes Topografía", "Auxiliares Control de Calidad", "Primas de Producción",
      ],
    },
    {
      titulo: "M.O. Directa T.I.",
      campos: ["Mano de obra directa en tareas indirectas"],
    },
    {
      titulo: "Dietas / Viajes",
      campos: ["Dietas", "Viajes", "Dietas PI", "Viajes PI", "Vehículos"],
    },
    {
      titulo: "Oficinas",
      campos: ["Oficinas, vestuarios y almacenes", "Servicios (agua, gas electricidad, teléfono)", "Acometidas"],
    },
    {
      titulo: "Maquinaria",
      campos: ["Maquinaria Ligera", "Transporte", "Medidas auxiliares"],
    },
    {
      titulo: "Herramientas",
      campos: ["Materiales auxiliares", "Herramientas", "Señalización y elementos de seguridad", "Material de oficina"],
    },
    {
      titulo: "Otros",
      campos: ["Anuncios", "Carteles", "Seguros", "Divulgación Informativa", "Publicidad Obra"],
    },
  ];

  const total = categorias
    .flatMap((cat) => cat.campos)
    .reduce((acc, campo) => {
      const fila = data[campo];
      return acc + (fila?.importe ? parseFloat(fila.importe) : 0);
    }, 0);

  return (
    <div className="glass-panel animate-fadeIn" style={{ padding: '32px', borderRadius: 'var(--radius-lg)', maxWidth: '1100px', margin: '0 auto' }}>
      <div className="dashboard-header" style={{ marginBottom: '32px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <div className="brand-logo" style={{ width: '48px', height: '48px', fontSize: '1.4rem' }}>
            <HiOutlineChartPie />
          </div>
          <div>
            <h2 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 800 }}>Detalle Costes Indirectos</h2>
            <p style={{ margin: 0, color: 'var(--text-secondary)', fontSize: '0.85rem' }}>Desglose pormenorizado de gastos fijos</p>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '12px' }}>
          <button className="btn-gestion" onClick={onCerrar} style={{ background: 'rgba(255,255,255,0.05)', color: 'var(--text-primary)' }}>
            <HiX /> Cerrar
          </button>
          <button className="btn-nueva" onClick={handleGuardar}>
            <HiSave /> Guardar Detalle
          </button>
        </div>
      </div>

      <div className="tabs-container" style={{ display: 'flex', gap: '8px', marginBottom: '32px', overflowX: 'auto', paddingBottom: '8px', borderBottom: '1px solid var(--glass-border)' }}>
        {categorias.map((cat, idx) => (
          <button
            key={cat.titulo}
            onClick={() => setActiveTab(idx)}
            style={{
              padding: '10px 20px',
              borderRadius: 'var(--radius-md)',
              border: 'none',
              background: idx === activeTab ? 'rgba(56, 189, 248, 0.1)' : 'transparent',
              color: idx === activeTab ? 'var(--accent-primary)' : 'var(--text-secondary)',
              fontWeight: idx === activeTab ? 700 : 500,
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              transition: 'var(--transition-fast)',
              borderBottom: idx === activeTab ? '2px solid var(--accent-primary)' : '2px solid transparent'
            }}
          >
            {cat.titulo}
          </button>
        ))}
      </div>

      <div className="tab-content animate-fadeIn">
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr 1.2fr', gap: '12px', padding: '0 16px 8px', color: 'var(--text-secondary)', fontSize: '0.75rem', fontWeight: 700, textTransform: 'uppercase' }}>
          <div>Concepto</div>
          <div>Número</div>
          <div>Meses</div>
          <div>Coste/Mes</div>
          <div style={{ textAlign: 'right' }}>Total</div>
        </div>
        <div className="cost-rows-list">
          {categorias[activeTab].campos.map(renderFila)}
        </div>
      </div>

      <div style={{
        marginTop: '32px',
        padding: '24px',
        background: 'rgba(56, 189, 248, 0.05)',
        border: '1px solid rgba(56, 189, 248, 0.2)',
        borderRadius: 'var(--radius-md)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <div style={{ fontWeight: 600, fontSize: '1.1rem' }}>Coste Total Indirectos Fijos</div>
        <div style={{ fontSize: '1.5rem', fontWeight: 800, color: 'var(--accent-primary)' }}>
          {total.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €
        </div>
      </div>
    </div>
  );
};

export default DetalleCostesIndirectos;
